<template>
  <el-container class="process-chart-design">
    <div class="aside-left">
      <div class="process-component-aside">
        <!-- 节点的组件放这里 -->
        <div class="node">
          <node-attr
            ref="nodeAttr"
            :node="getNode"
            :startNodeId="definition.process.startNode"
            @selectPerson="selectPerson">
          </node-attr>
        </div>
        <!-- 流转的组件 -->
        <div class="connection-component">
          <div v-for="(connection, connectionIndex) in connections" :key="connection.id">
            <process-connection
              :connections="connections"
              :connection="connection"
              :connectionIndex="connectionIndex"
              :definition="definition"
              :currentNodeId="currentNodeId"
              :getNodes="getNodes"
              @delConnection="delConnection"
              @openDialogInform="openDialogInform">
            </process-connection>
          </div>
          <el-button class="add-connection" type="text" @click="addConnection"><i>+</i> 添加流转</el-button>
        </div>
        <el-button class="save" type="primary" @click="saveConnection">保存</el-button>
      </div>
    </div>
    <el-main>
      <node-drag
        :startNode="definition.process.startNode"
        :nodes="getNodes"
        :connections="getConnections"
        :currentNodeId="currentNodeId"
        @addNode="addNode"
        @updatePosition="updatePosition"
        @selectNodeiId="selectNodeiId"
        @removeNode="removeNode">
      </node-drag>
    </el-main>
  </el-container>
</template>
<script>
import ProcessConnection from './process-connection.vue'
import NodeDrag from './process-node-drag'

import Connection from '@/store/process/connection.js'
import _ from 'lodash'
import NodeAttr from './process-node-attr'

export default {
  name: 'ProcessChart',
  props: ['definition', 'currentTask'],
  inject: ['processService'],
  components: {
    ProcessConnection,
    NodeDrag,
    NodeAttr
  },
  data () {
    let nodeId = this.currentTask || this.definition.process.startNode
    let connections = _.cloneDeep(this.definition.process.connections.filter(m => m.sourceNodeId === nodeId))
    return {
      currentNodeId: nodeId,
      connections
    }
  },

  watch: {
    'currentTask' (currentTask) {
      this.currentNodeId = currentTask
    },
    // 为了二次加载时,选中发起节点
    'definition.process.startNode' (nodeId) {
      this.currentNodeId = this.definition.process.startNode
      this.connections = _.cloneDeep(this.definition.process.connections.filter(m => m.sourceNodeId === nodeId))
    },
    'currentNodeId' (nodeId) {
      let connections = this.definition.process.connections.filter(m => m.sourceNodeId === nodeId)
      if (connections) {
        this.connections = _.cloneDeep(connections)
      }
    },
    'definition.process.connections': {
      // 这个监听data中的connections,因为新拖入一个节点,connections不会改变,目标节点的线会链接错误,重新重新赋值
      handler (value) {
        this.connections = _.cloneDeep(this.definition.process.connections.filter(m => m.sourceNodeId === this.currentNodeId))
      },
      deep: true
    }

  },
  methods: {
    // 增加节点
    addNode (node) {
      this.$emit('addNode', node)
    },
    // 修改节点位置信息
    updatePosition (node) {
      this.$emit('updatePosition', node)
    },
    selectNodeiId (nodeId) {
      // 为了获取当前节点前的节点的控件
      let path = []
      this.definition.process.getPaths(this.currentNodeId)[0] && this.definition.process.getPaths(this.currentNodeId)[0].split('->').forEach(m => {
        path.push(this.definition.process.nodes.find(n => n.id === m).formId)
      })
      this.processService.formService.component.path = path
      if (nodeId !== this.currentNodeId) {
        let connections = _.cloneDeep(this.processService.getConections(this.currentNodeId))
        // 这个地方做保存判断.判断是否点击保存按钮
        if (JSON.stringify(connections) === JSON.stringify(this.connections)) {
          this.currentNodeId = nodeId
          this.$emit('setCurrentNodeId', this.currentNodeId)
        } else {
          this.$confirm('', '是否保存当前节点的设置?', {
            confirmButtonText: '立即保存',
            cancelButtonText: '暂不保存',
            customClass: 'publishMessageBox',
            center: true
          }).then(() => {
            this.saveConnection()
              .then(() => {
                this.currentNodeId = nodeId
                this.$emit('setCurrentNodeId', this.currentNodeId)
              }).catch((res) => {
                // 这个catch不删,不然不会出提示
              })
          }).catch(() => {
            this.currentNodeId = nodeId
            this.connections = connections
          })
        }
      }
    },
    removeNode (nodeId) {
      if (this.definition.process.startNode === nodeId) {
        this.$message.info('起始节点不可删除.')
      } else {
        if (this.currentNodeId === nodeId) {
          this.currentNodeId = this.definition.process.startNode
          this.$emit('setCurrentNodeId', this.currentNodeId)
        }
        this.$emit('removeNode', nodeId)
      }
    },
    // 添加线
    addConnection () {
      let connection = Connection.create({ 'sourceNodeId': this.currentNodeId })
      this.connections.push(connection)
    },
    delConnection (conditionIndex, connectionId) {
      // 删除流转前提示用户先删除节点交互中下拉框选择的流转
      let hasInteractions = false
      this.definition.process.attribute.interactions.forEach(item => {
        if (item.triggerConnections && item.triggerConnections.length > 0) {
          if (item.triggerConnections.some(id => id === connectionId)) {
            this.$message.info('请先删除节点交互中选择的流转')
            hasInteractions = true
          }
        }
      })
      if (hasInteractions) {
        return null
      } else {
        this.connections.splice(conditionIndex, 1)
      }
    },
    saveConnection () {
      let connections = this.connections
      let currentNodeId = this.currentNodeId
      // 保存前先确保流转中都有值
      for (let i = 0; i < connections.length; i++) {
        let usefulConditions = []
        if (connections[i].operationType === '') {
          this.$message.info('请填写流转操作类型')
          return Promise.reject(new Error('请填写流转操作类型.'))
        }
        if (connections[i].targetNodeId === '') {
          this.$message.info('请填写流转目标节点')
          return Promise.reject(new Error('请填写流转目标节点.'))
        }
        if (this.getNode.type !== 'inclusiveGateway_start' && this.getNode.type !== 'inclusiveGateway_end' && connections[i].actionId === '') {
          this.$message.info('请选择操作按钮')
          return Promise.reject(new Error('请选择操作按钮.'))
        }
        // 如果是会签节点，保存的时候流转条件不允许
        let currentNode = this.definition.process.nodes.find(n => n.id === this.currentNodeId)
        if (currentNode.isCountersign && connections[i].conditions.length > 0) {
          this.$message.info('会签节点不允许有流转条件')
        }
        // 流转条件为未填写完整,不存
        connections[i].conditions.forEach(m => {
        //  流转条件的操作符是非空或者空,不需要默认值
          if (m.fieldId !== '' && m.nodeId !== '' && (m.operator === 'Null' || m.operator === 'notNull')) {
            usefulConditions.push(m)
          } else if (m.fieldId !== '' && m.nodeId !== '' && m.operator !== '' && m.value !== '') {
            usefulConditions.push(m)
          }
        })
        connections[i].conditions = usefulConditions
      }

      this.processService.saveConnections({connections, currentNodeId})
      this.$message({
        message: '保存成功!',
        center: true,
        customClass: 'message-save',
        type: 'success'
      })
      return Promise.resolve()
    },
    selectPerson (object) {
      this.$emit('selectPerson', object)
    },
    openDialogInform (informMessage) {
      this.$emit('openDialogInform', informMessage)
    },
    nodeAttrValidate () {
      return this.$refs.nodeAttr.nodeFormValidate()
    }
  },
  computed: {
    getNodes () {
      return this.definition.process.nodes.filter(m => {
        return m.type !== 'cancelEvent' && m.type !== 'endEvent'
      })
    },
    getConnections () {
      let connections = []
      if (this.definition) {
        connections = this.definition.process.connections
      }
      return connections
    },
    getNode () {
      return this.definition.process.nodes.find(m => m.id === this.currentNodeId)
    }
  }
}
</script>
<style lang="scss">
.process-chart-design {
  height: 100%;
  background: #f8fbfe;
  margin-top: 16px;

  .aside-left {
    width: 536px;
    float: left;
    padding: 10px;
    padding-left: 0;
    box-shadow: 0px 3px 8px 0px rgba(184, 222, 253, 0.2);
    margin-right: 12px;
    background: #fff;
    height: 100%;

    .process-component-aside {
      width: 100%;
      border: 1px solid #c2c3c4;
      border-radius: 4px;
      height: 100%;
      position: relative;
      padding-bottom: 10px;
      overflow: auto;

      .node {
        width: 100%;
        margin-bottom: 15px;
      }

      .connection-component {

        .add-connection {
          margin: 0 auto;
          display: block;
          margin-top: 30px;
        }
      }

      .save {
        width: 106px;
        position: relative;
        margin-top: 35px;
        left: 50%;
        margin-left: -53px;
        clear: both;
      }
    }
  }

  .el-main {
    float: right;
    width: calc(100% - 550px);
    height: 100%;
    background: #fff;
    padding: 0 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-chart.vue